import '../../styles/FarolCard.css'
import FarolListContainer from '../Lists/FarolListContainer'
import InlineEditableText from './InlineEditableText'

function FarolCard({ 

        faroTerminalId, 
        terminalName, 
        isShipDockered, 
        description, 
        shipDescription, 
        farols, 
                
        handleDeleteCard,
        handleCreateFarol,
        handleUpdateField,

        isAddingFarol,
        handleAddingFarolDone,

        hasPermission,
        isStacked

    }) {

    return (

        <div className={`border-[1px] border-[solid] border-[#dfdfdf] ${isStacked ? 'w-full' : 'w-[370px]'} p-2 rounded-[7px] flex flex-col gap-2 [transition:ease_0.3s_all] hover:[box-shadow:rgba(0,_0,_0,_0.16)_0px_1px_4px]`}>
            
            <header className="flex justify-between h-[fit-content] " >
                
                <h2 className="text-[1.2rem]">{terminalName}</h2>

                
                {/* Com permissão o selo vira botão que alterna o status; sem permissão é só texto, sem hover. */}
                {hasPermission ? (

                    <button
                        type="button"
                        onClick={() => handleUpdateField('isShipDockered', !isShipDockered)}
                        title={isShipDockered ? 'Clique para marcar como Sem Navio' : 'Clique para marcar como Navio Atracado'}
                        className={`text-[white] px-[7px] py-[5px] rounded-[5px] text-[0.8rem] h-fit cursor-pointer transition-[filter,box-shadow] hover:brightness-95 hover:[box-shadow:0_0_0_2px_rgba(0,0,0,0.12)] ${isShipDockered ? 'bg-amarelo-ouro-m' : 'bg-[#E5E5E5]'}`}
                    >
                        {isShipDockered ? 'Navio Atracado' : 'Sem Navio'}
                    </button>

                ) : (

                    <div className={`text-[white] px-[7px] py-[5px] rounded-[5px] text-[0.8rem] h-fit ${isShipDockered ? 'bg-amarelo-ouro-m' : 'bg-[#E5E5E5]'}`}>
                        {isShipDockered ? 'Navio Atracado' : 'Sem Navio'}
                    </div>

                )}
                
            </header>

            <section className="flex flex-col gap-2" >

                <div>
                    <InlineEditableText
                        value={shipDescription === '--' ? '' : shipDescription}
                        onSave={(value) => handleUpdateField('shipDescription', value || '--')}
                        canEdit={hasPermission}
                        placeholder='Informações do navio'
                        className='text-[0.8rem] text-[darkgray]  leading-[18px] font-sans min-h-[20px]'
                    />
                </div>

                <div>
                    <InlineEditableText
                        value={description}
                        onSave={(value) => handleUpdateField('description', value)}
                        canEdit={hasPermission}
                        multiline
                        placeholder='Descrição'
                        className='text-[0.8rem]  text-[darkgray] font-bold leading-[18px] font-sans min-h-[20px]'
                    />
                </div>

            </section>

            <FarolListContainer
                faroTerminalId={faroTerminalId}
                farols={farols}
                hasPermission={hasPermission}
                isAddingFarol={isAddingFarol}
                onAddingFarolDone={handleAddingFarolDone}
            />
            
            {hasPermission && (
                <footer className="flex flex-row gap-2 border-[none] h-[36px]">
                
                <button 
                    className="btn btn-vermelho [aspect-ratio:1_/_1]"
                    onClick={() => {handleDeleteCard(faroTerminalId)}}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" height="18px" data-name="Layer 1" viewBox="0 0 24 24">
                        <path d="m23,4h-6v-2c0-1.103-.897-2-2-2h-6c-1.103,0-2,.897-2,2v2H1v2h1.644l1.703,15.331c.169,1.521,1.451,2.669,2.982,2.669h9.304c1.531,0,2.813-1.147,2.981-2.669l1.703-15.331h1.682v-2Zm-14-2h6v2h-6v-2Zm8.626,19.11c-.056.507-.483.89-.994.89H7.329c-.51,0-.938-.383-.994-.89l-1.679-15.11h14.65l-1.679,15.11Zm-9.583-4.567l2.543-2.543-2.543-2.543,1.414-1.414,2.543,2.543,2.543-2.543,1.414,1.414-2.543,2.543,2.543,2.543-1.414,1.414-2.543-2.543-2.543,2.543-1.414-1.414Z"/>
                    </svg> 
                </button>

                <button 
                    className={`btn btn-azul-prof w-[100%] ${isStacked ? 'max-w-[220px]' : ''}`}
                    onClick={() => {handleCreateFarol(faroTerminalId)}}
                >
                    Adicionar
                </button>

            </footer>
            )}
        </div>
    
    )
}

export default FarolCard;